/**
 * Languages shipped with the package. English is bundled; every other pack is a separate file loaded only when a
 * page needs it (npm: a code-split chunk, CDN: `lang/<code>.json` next to kockica.min.js). ADR-023.
 */
export const BUILT_IN_LANGUAGES = [
  'en', 'sl', 'de', 'hr', 'it', 'fr', 'es', 'pt', 'nl', 'da', 'pl', 'cs', 'sk', 'hu', 'bg', 'uk', 'ru', 'el', 'sq',
] as const;

export type BuiltInLanguage = (typeof BUILT_IN_LANGUAGES)[number];

export function isBuiltInLanguage(code: string): code is BuiltInLanguage {
  return (BUILT_IN_LANGUAGES as readonly string[]).includes(code);
}
